import { apiClient } from "../api"
import { stringifyParams } from "../utils/api"
import {
  AreaMonitoringParam,
  DTO_AreaMonitoringReport,
  DTO_EmissionsReport,
  DTO_FuelPurchaseReport,
  DTO_IdleStopsReport,
  DTO_MaintenanceReport,
  DTO_SpeedViolationReport,
  DTO_TemperatureQualityMonitoring,
  DTO_TemperatureQualityReport,
  DTO_TemperatureReport,
  DTO_WeeklyWorkingReport,
  EmissionsReportParam,
  FuelPurchaseReportParam,
  IdelStopReportParam,
  MaintenanceParam,
  SpeedViolationParam,
  TemperatureQualityMonitoringParam,
  TemperatureQualityParam,
  TemperatureReportParam,
  WeeklyWorkingReportParam,
} from "./types/reports"

const API_REPORTS = '/reports/'

export const getVehicleReport = (params: any) => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}vehiclereport/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getTachographReport = (params: any) => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}tachograph/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getTagReport = (params: any) => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}tags/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getDayOverviewReport = (params: any) => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}day_overview/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getFuelPurchasesReport = (params: FuelPurchaseReportParam): Promise<DTO_FuelPurchaseReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}fuelpurchase/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getEmissionsReport = (params: EmissionsReportParam): Promise<DTO_EmissionsReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}emissions/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getTemperatureReport = (params: TemperatureReportParam): Promise<DTO_TemperatureReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}temperature/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getAreaMonitoringReport = (params: AreaMonitoringParam): Promise<DTO_AreaMonitoringReport[]> => {
  const ac = apiClient()
  const filterOutVisited = params.visited
  delete params.visited
  const queryStr = stringifyParams(params)
  const addUrlString = filterOutVisited ? 'unvisited_locations/' : ''
  const promise = ac.get(`${API_REPORTS}areamonitoring/${addUrlString}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getSpeedViolationReport = (params: SpeedViolationParam): Promise<DTO_SpeedViolationReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}speeding/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getTemperatureQualityMonitoringReport = (params: TemperatureQualityMonitoringParam): Promise<DTO_TemperatureQualityMonitoring[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}temperature_quality_monitoring/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getMaintenanceReport = (params: MaintenanceParam): Promise<DTO_MaintenanceReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}maintenance/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getTemperatureQualityReport = (params: TemperatureQualityParam): Promise<DTO_TemperatureQualityReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}temperature_quality/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getIdleStopsReport = (params: IdelStopReportParam, type: string = 'year'): Promise<DTO_IdleStopsReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}idlestops/${type}/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getWeeklyWorkingHoursReport = (params: WeeklyWorkingReportParam, type: string = 'year'): Promise<DTO_WeeklyWorkingReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}weekly_hours/${type}/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getVehicleDistanceReport = (params: WeeklyWorkingReportParam, type: string = 'year'): Promise<DTO_WeeklyWorkingReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${API_REPORTS}vehicle_distance/${type}/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}
